import styled from "styled-components";

const Skill = ({ image, desc, name }) => {
  return (
    <Card>
      <img src={image} alt={desc} />
      <span>{name}</span>
    </Card>
  );
};

const Card = styled.div`
  width: max-content;
  border: 1px solid #aaaaaa;
  border-radius: 5px;
  padding: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  img {
    height: 2rem;
    width: 2rem;
  }
  span {
    font-weight: bold;
  }

  @media screen and (max-width: 600px) {
    img {
      height: 1.2rem;
      width: 1.2rem;
    }
    span {
      font-size: 0.8rem;
    }
  }
`;

export default Skill;
